export default "__VITE_ASSET__Cyjtj9NE__"